export const ACTION = {
  REFERENCE: 'reference',
  TRACKING: 'tracking',
  UPLOAD_SFP_PHOTO: 'upload_sfp_photo',
  UPLOAD_CFN_PHOTO: 'upload_cfn_photo',
  CHANGE_COLLECTION_OPTION: 'change_collection_option',
};
